// external imports
import React from 'react'
// local imports
import { Header, Text } from '~/components'
import image from './img.jpg'

const ProductSummaryEmptyState = () => (
    <React.Fragment>
        <Header>Products</Header>
        <Text>
            Lark Seeds International supports several breeding programs in cucurbits and solanum.
        </Text>
        <Text>
            We develop our product line by working closely with customers to understand the needs of local markets.
            Each product is aimed at specific market demands that vary from environmental conditions to consumer needs.
        </Text>
        <Text>
            With over two hundred varieties currently on the market spanning across nine vegetables species,
            we are confident Lark Seeds International’s extensive portfolio has what you are looking for.
        </Text>
        <img src={image} />
    </React.Fragment>
)

export default ProductSummaryEmptyState



// WEBPACK FOOTER //
// ./src/views/Products/ProductSummary/Empty/index.js